// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import ServicePageTemplate from 'presentations/views/components/templates/ServicePageTemplate';
import EventTypeHeader from 'presentations/views/components/organisms/EventTypeHeader';
import TeamHeader from 'presentations/views/components/organisms/TeamHeader';
import UserEventTypeList from 'presentations/views/components/organisms/UserEventTypeList';
import { mediaMax, spacing } from 'presentations/views/styles';
import { ViewerItem } from 'presentations/api/schema/user';
import BoxHeadline from 'presentations/views/components/molecules/BoxHeadline';
import { TeamItem } from 'presentations/api/schema/team';
import { SharedEventTypeListItem } from 'presentations/api/schema/event_type';

interface Props {
  team: TeamItem;
  viewer: ViewerItem | null;
  isLoading?: boolean;
  eventTypes: SharedEventTypeListItem[];
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  // const router = useRouter();
  // const isHost = useMemo(() => {
  //   const teamId = String(router.query.teamId);
  //   return props.viewer && props.viewer.team?.uid === teamId;
  // }, [props.viewer, router]);
  return (
    <ServicePageTemplate
      header={
        <EventTypeHeader
          viewer={props.viewer}
          headerTeamImage={props.team.headerTeamImage}
        />
      }
      breadcrumbs={[]}
      isHiddenFooter={!!props.team.headerTeamImage}
      isHiddenContentFooter={true}
    >
      <PageContainer>
        <Container>
          <HeaderContainer>
            <TeamHeader
              name={props.team.name!}
              slug={props.team.slug}
              profile={props.team.profile}
              profileImage={props.team.profileImage}
            />
          </HeaderContainer>
          <Content>
            <HeadlineContainer>
              <BoxHeadline iconName="calendar-month">
                {t('event type list')}
              </BoxHeadline>
            </HeadlineContainer>
            {props.eventTypes.length > 0 ? (
              <UserEventTypeList
                isLoading={props.isLoading}
                teamSlug={props.team.slug}
                eventTypes={props.eventTypes}
              />
            ) : (
              t('empty')
            )}
          </Content>
        </Container>
      </PageContainer>
    </ServicePageTemplate>
  );
}

const PageContainer = styled.div``;
const Container = styled.div``;
const HeaderContainer = styled.div`
  margin: 0 auto ${spacing(48)};
`;

const HeadlineContainer = styled.div`
  margin: 0 auto;
  margin-bottom: ${spacing(24)};
`;

const Content = styled.div`
  max-width: 960px;
  margin: 0 auto;
  ${mediaMax.tablet} {
    padding: 0 ${spacing(12)};
  }
`;
